import Isotope from "isotope-layout";
document.addEventListener("DOMContentLoaded", function () {
  var buttons = document.querySelectorAll(".projects__categories li");
  var grid = document.querySelector(".grid");
 
  if (grid) {
    var iso = new Isotope(grid, {
      itemSelector: ".grid-item",
      layoutMode: "fitRows",
      percentPosition: true,
      masonry: {
        columnWidth: ".grid-sizer",
      },
    });

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var filterValue = this.getAttribute("data-filter");
        iso.arrange({ filter: filterValue });

        buttons.forEach(function (btn) {
          btn.classList.remove("active");
        });
        this.classList.add("active");
      });
    });
  }
});
